import { ClockIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { dates } from "@/lib/dates";
import { cn } from "@/lib/utils";

// Full overdue pill (clock + relative day). Minimized rows show the clock alone
// and reveal this on hover; the expanded list renders it inline. `compact` trims
// the vertical height for dense lists (e.g. the notifications dropdown).
export const DashboardTaskOverdueBadge = ({
  dueDate,
  compact = false,
}: {
  dueDate: string;
  compact?: boolean;
}) => {
  const render = () => (
    <Row
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-lever-border-error bg-lever-surface-error px-2",
        compact ? "py-0" : "py-0.5",
      )}
    >
      <ClockIcon className="h-3 w-3 shrink-0 text-lever-text-error" />
      <Text
        className={cn(
          "text-[11px] font-medium text-lever-text-error",
          compact && "leading-none",
        )}
      >
        {dates.relativeDayLabel(dates.taskDueDate(dueDate))}
      </Text>
    </Row>
  );

  return render();
};
